<template>
  <div>
    <!-- <ul>
    <li v-for="tab in tabs" :key="tab.path">
        <router-link :to="tab.path">{{ tab.name }}</router-link>
      </li>
    </ul> -->
    <v-card
    width="600px"
    class="ml-auto"
    color="#91808b"
    > 
      <!-- <v-card-title class="s" style="text-align: center;">
        Select
      </v-card-title> -->
      <!-- <v-tabs
        v-model="tab"
        color="primary"
        direction="vertical"
      >
      <v-tab v-for="tab in tabs" 
        :key="tab.path"
        :class="{ active: $route.path === tab.path }" 
        @click="$router.push(tab.path)"
        >{{ tab.name }}
      </v-tab>
      </v-tabs> -->
    <div class="tabs">
      <div class='tabs-header'>CPTAC Melanoma studies:</div>
      <v-btn 
        v-for="tab in tabs" 
        :key="tab.path" 
        :class="{ active: $route.path === tab.path }" 
        @click="$router.push(tab.path)"
      >
        {{ tab.name }}
      </v-btn>
    </div>
    </v-card>

    <!-- <v-card>
          <v-tabs vertical
      v-model="tab"
      align-tabs="end"
      color="deep-purple-accent-4"
    >
     <v-tab v-for="tab in tabs" 
        :key="tab.path" 
        :class="{ active: $route.path === tab.path }" 
        @click="$router.push(tab.path)"> {{ tab.name }}</v-tab>
    </v-tabs>
    </v-card> -->
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        // { path: '/dashboard', name: 'dashboard' },
        // { path: '/dashboard2', name: 'dashboard 2' }
        // { path: '/ptrc', name: 'PTRC' },
        // { path: '/pcc', name: 'PCC' }
        { path: '/ptrc', name: 'ICI subtype study (Chowhury et. al.)', studyName: 'PTRC' },
        { path: '/pcc', name: 'Multi-omics atlas study (Gong et. al.)', studyName: 'PCC' }
      ]
    }
  }
}
</script>

<style scoped>
/* .tabs {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #ccc;
}

.tabs button {
  padding: 10px 20px;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  margin: 0 10px;
} */

/* .tabs button.active {
  border-bottom-color: #007bff;
  background-color: #fff;
  color: #007bff;
  font-weight: bold;
} */


/* .v-btn {
  height: auto;
  word-wrap: break-word;
} */
/* .v-btn {
  margin: 20px;
} */

.tabs {
  display: flex;
  flex-direction: column; 
  align-items: center;
  /* width: 70%; */
}

.tabs button {
  padding: 20px 20px;
  border: none;
  border-top: 5px;
  border-bottom: 2px solid transparent;
  background-color: #fff;
  cursor: pointer;
  margin: 10px; /* Add margin to separate buttons */
  width: 90%; 
  font-size: 0.85em;
  min-height: 55px;
  max-height: 80px;
  /* height: auto; */
  display: flex;
  flex-direction: column; 
  white-space: normal;
  align-items: stretch;
  /* word-wrap: break-word; */
}

.tabs button.active {
  border-bottom-color: #007bff;
  background-color: #d4eaec;
  color: #007bff;
  font-weight: 1000;
  font-size: 0.9em;
}

.tabs-header {
  /* font-size: 1.2em; */
  /* margin-bottom: 10px; */
  color: white;
  font-size: 1.2em;
  font-weight: 500;
}

</style>